"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ouroboro = void 0;
var ouroboro_1 = require("./ouroboro");
Object.defineProperty(exports, "Ouroboro", { enumerable: true, get: function () { return ouroboro_1.Ouroboro; } });
//# sourceMappingURL=index.js.map